import { RouterLink } from '../../../generic';
import Text from '../../../generic/Text';

/**
 * Display a link to the organization users page.
 */
const EmailAddressConfiguration = () => {
  return (
    <>
      <Text.H3>Email Address Configuration</Text.H3>
      <div className="gray-rounded-box">
        <Text.Paragraph>
          You can manage the members (using their email address to login) that are part of this organization on the{' '}
          <RouterLink to="/account/settings/organization/users">Organization Users</RouterLink> page.
        </Text.Paragraph>
      </div>
    </>
  );
};

export default EmailAddressConfiguration;
